import React from "react";

import { useCurrentProjectContext } from "@editor/contexts/CurrentProjectContext";
import useCurrentProjectId from "@editor/hooks/useCurrentProjectId";
import { isFeatureEnabled } from "@editor/infra/featureFlags";
import { trpc } from "@editor/utils/trpc";

import { CANVAS_DATA } from "@/features/canvas/canvas-constants";
import ReactEditorChat from "@/features/react-editor/components/chat/ReactEditorChat";
import PageRenderer from "@/features/react-editor/components/PageRenderer";
import { useViewportStore } from "@/features/react-editor/store/viewportStore";
import { skipToken } from "@tanstack/react-query";
import { Navigate, useParams } from "react-router-dom";

function ReactEditor() {
  const isReaplo = isFeatureEnabled("reaplo");
  const { project } = useCurrentProjectContext();
  const projectId = useCurrentProjectId();
  const { pageId } = useParams();

  const currentViewport = useViewportStore((state) => state.currentViewport);

  const { data: page } = trpc.nextJSProject.getPageComponent.useQuery(
    projectId ? { projectId, id: pageId ?? "" } : skipToken,
    {
      enabled: Boolean(projectId && pageId),
    },
  );

  if (!project) {
    return null;
  }

  if (!isReaplo) {
    return <Navigate to={`/projects/${project.id}`} replace />;
  }

  return (
    <div className="flex gap-3 h-full w-full">
      <div className="flex h-full flex-col gap-5 border-border border-t-0.5 w-1/3">
        <div className="flex-1 min-h-0 flex justify-center w-full">
          <ReactEditorChat />
        </div>
      </div>

      <div className="border-0.5 border-border flex-1 min-h-0 flex items-center justify-center rounded-lg bg-neutral-soft">
        <div
          className="flex h-full w-full items-center justify-center"
          style={{
            maxWidth:
              currentViewport !== "desktop"
                ? `${CANVAS_DATA[currentViewport].defaultFrameWidth}px`
                : undefined,
          }}
        >
          {page && (
            <PageRenderer
              pageRoute={page.pageRoute ?? ""}
              className="rounded-lg"
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default ReactEditor;
